import { ref } from 'vue'
import supplierHttp from '@supplier/http/supplierHttp'
import Cookies from 'js-cookie'

import { useSupplierNotify } from '@supplier/composables/useSupplierNotify'

import { SUPPLIER_API } from '@supplier/http/api-routes'

import { clearCookie } from '@/utils/authWatcher'
import { IMPERSONATION_COOKIES } from '@supplier/consts'

export function useSupplierImpersonation() {
  const notify = useSupplierNotify()
  const isImpersonating = Boolean(Cookies.get('isAdminLoginAsUser'))
  const isLeaving = ref(false)

  async function leaveImpersonation() {
    if (isLeaving.value) return
    isLeaving.value = true
    try {
      const { data } = await supplierHttp.post(SUPPLIER_API.loginAsAdmin, { id: Cookies.get('logged_in_admin_id') ?? '' })
      if (data?.status === 'success') {
        IMPERSONATION_COOKIES.forEach((name) => clearCookie(name))
        window.location.assign(`${window.config?.adminurl ?? ''}/users`)
        return
      }
      notify.error(data?.message)
    } catch (error) {
      notify.error(error)
    }
    isLeaving.value = false
  }

  return { isImpersonating, isLeaving, leaveImpersonation }
}
